import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { CreateAprendizWithUserInput } from "@/lib/validaciones/createAprendizWithUsuario.validacion";
import { toast } from "sonner";
import { axiosInstance } from "@retro-ia/shared/axios";

export const useRegisterAprendizWithUsuario = (
  idPrograma?: number,
  queryKey: (string | number | undefined)[] = ["aprendices"]
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateAprendizWithUserInput) => {
      let url = "/aprendices/with-user";
      if (idPrograma) {
        url += `?idPrograma=${idPrograma}`;
      }
      const response = await axiosInstance.post(url, data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
      queryClient.refetchQueries({ queryKey });
      toast.success("Se ha registrado correctamente.");
    },
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Ocurrió un error al registrar el aprendiz.";
      toast.error(errorMessage);
    },
  });
};
